import { render, staticRenderFns } from "./big-scree-seclet.vue?vue&type=template&id=710f116d&"
import script from "./big-scree-seclet.vue?vue&type=script&lang=js&"
export * from "./big-scree-seclet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports